<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
              :showBtn="false"
              :showAddNew="false"
              title="Reward Import List"
            >
            <template #extra-btn>
              <a
                  download
                  href="/file/import-reward-point-list.xlsx"
                  class="btn btn-outline-secondary waves-effect waves-float waves-light"
              >Download Sample
              </a>
            </template>
          </TitleButton>
            <input type="file" class="d-none" ref="uploader" @change="handleFileUpload">
        </div>

        <div class="row p-2">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3">
              <label class="align-middle">Reward Point Expense Account (P&L)</label>
              <AsyncSelect
                  placeholder="Select Account Head"
                  :api-service="fetchAccountHeadsList"
                  :reduce="(name) => name.id"
                  v-model="accountHeadId"
                  :additional-query="{cash_bank_hide: 'yes', status: 'active'}"
                  :format-label="formatPatientLabel"
              />
            </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <label class="align-middle">Reward Point Liability Account</label>
            <v-select
                placeholder="Select Liability Head"
                :options="rewardPointAcc"
                :reduce="(name) => name.id"
                v-model="liabilityHeadId"
                label="name"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-2">
            <label class="align-middle">Adjustment Date</label>
            <input type="date" class="form-control" v-model="adjustmentDate">
          </div>

            <div v-if="liabilityHeadId && accountHeadId && adjustmentDate" class="col-12 col-sm-6 col-md-4 col-lg-2 mt-auto">
                <button @click="uploadCsv" class="btn btn-primary waves-effect waves-float waves-light">
                    Browse
                </button>
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-2 mt-auto">
                <button @click="getCsvRow" class="btn btn-primary waves-effect waves-float waves-light">
                    Get CSV
                </button>
            </div>
        </div>

        <div class="p-2">
            <div v-for="(item, index) in csvRow" :key="index">
                <div class="py-1 bg-black-light rounded-8 mb-2 d-flex justify-content-between align-items-center">
                    <span class="cursor-pointer px-1" @click="gotoUpload(item.id)">id: {{ item.id }} Dataset: {{ item.batch }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted, inject } from 'vue';
    import {useRoute, useRouter} from 'vue-router';
    import handleInventory from "@/services/modules/inventory";
    import TitleButton from '@/components/atom/TitleButton.vue';
    import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
    import { useAsyncDropdownHelper } from "@/services/utils/asyncDropdownHelper";
    import handlePurchase from '@/services/modules/purchase'
    import handleJournal from '@/services/modules/journal';

    const route = useRoute();
    const router = useRouter();
    const {  fetchHome, uploadRewardPointCsvFile, fetchCsvRow } = handleInventory();
    const { formatPatientLabel } = useAsyncDropdownHelper();
    const { getAccountHeadBySlag } = handlePurchase();
    const { fetchAccountHeadsList } = handleJournal();

    const selectedFile = ref(null);
    const fileName = ref('');
    const uploader = ref(null);
    const uploadLog = ref([]);
    let accountHeads = ref([])
    let liabilityHeadId = ref(null)
    let accountHeadId = ref(null)
    let adjustmentDate = ref(null)
    const product_type = ref(null);
    const csvRow = ref([]);
    const showError = inject('showError');
    const showSuccess = inject('showSuccess');
    const rewardPointAcc = ref([]);

    const getRewardPointAccounts = async () => {
      const query = `?company_id=${route.params.companyId}`

      try {
        const res = await getAccountHeadBySlag('reward_points', query);
        if(! res.status) {
          return;
        }
        rewardPointAcc.value = res.data;
      } catch (e) {
        console.log('Something went wrong');
      }
    }

    onMounted(() => {
        adjustmentDate.value = new Date().toISOString().split('T')[0]

        Promise.all([
            getRewardPointAccounts(),
            getCsvRow()
        ]).catch(e => showError('Something went wrong'))
    })

    const uploadCsv = () => {
        uploader.value.click();
    }

    const getCsvRow = () => {
        let query = `?company_id=${route.params.companyId}&type=reward_point`;

        fetchCsvRow(query).then((res) => {
            if(!res.status) {
                return
            }
            showSuccess(res.message)
            csvRow.value = res.data
        }).catch(e => showError('Something went wrong'));
    }

    const gotoUpload = (id) => {
        route.query.rowId = id;
        router.push({name: 'upload-reward-point', params: route.params, query: route.query});
    }

    const handleFileUpload = (event) => {
        selectedFile.value = event.target.files[0];
        fileName.value = event.target.files[0].fileName

        let fd = new FormData();
        fd.append('company_id', route.params.companyId)
        fd.append('sheet', selectedFile.value)
        fd.append('liability_head_id', liabilityHeadId.value)
        fd.append('account_head_id', accountHeadId.value)
        fd.append('date', adjustmentDate.value)
        fd.append('type', 'reward_point')

        uploadRewardPointCsvFile(fd).then((res) => {
            if(!res.status) {
                showError(res.message)
                return
            }
            
            showSuccess(res.message)
            uploadLog.value = res.data
        }).catch(e => showError('Something went wrong'));
    }
</script>